module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-checkbox-group",
    attrs: {
      "role": "group",
      "aria-label": "checkbox-group"
    },
    on: {
      "keydown": _vm.handleKeydown
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73297089"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/checkbox/src/checkbox-group.vue
// module id = 2184
// module chunks = 137